import { requests } from '../../agent/agent';
import { ProductForGetAllProductsCategoriesResponse } from './responses/getAllProductsCategoriesResponse';

export const ProductCategoriesApi = {
	getAllProductCategories: (): Promise<ProductForGetAllProductsCategoriesResponse[]> =>
		requests.get(`/productsCategories`)
};
